import { Container, Box } from '@mui/material';
import HourRangeFilter from '../HourRangeFilter';
import AvailableLinesButton from './AvailableLinesButton';
import NotEscaletedLinesNextButton from './NotEscaletedLinesNextButton';
import NotEscaletedLinesTodayButton from './NotEscaletedLinesTodayButton';
import EscaletedLinesTodayButton from './EscaletedLinesTodayButton';
import AlertN1Button from './AlertN1Button';
import AlertN2Button from './AlertN2Button';
import AlertN3Button from './AlertN3Button';
import { usePermissions } from '../../hooks/auth/usePermissions';
import { useOperationalMapStore } from '../../stores/useOperationalMapStore';
import { useLayoutStore } from '../../hooks/screen/useLayoutStore';

const TopAlerts = () => {
    
    const { canTripsOnly } = usePermissions();

    const isOperationalMapMode = useOperationalMapStore(
        state => state.isOperationalMapMode
    );

    const isCompactMode = useLayoutStore(
        state => state.isCompactMode
    );

    const alerts = (
        <>
            <AvailableLinesButton isCompactMode={isCompactMode} />
            <NotEscaletedLinesNextButton isCompactMode={isCompactMode} />
            <NotEscaletedLinesTodayButton isCompactMode={isCompactMode} />
            <EscaletedLinesTodayButton isCompactMode={isCompactMode} />
            <AlertN1Button isCompactMode={isCompactMode} />
            <AlertN2Button isCompactMode={isCompactMode} />
            <AlertN3Button isCompactMode={isCompactMode} />
        </>
    );

    return (
        <>
            {isCompactMode ? (

                !canTripsOnly && !isOperationalMapMode && (
                    <Box
                        sx={{
                            position: 'fixed',
                            left: 0,
                            top: '50%',
                            transform: 'translateY(-50%)',
                            padding: 1,
                            display: 'flex',
                            flexDirection: 'column',
                            alignItems: 'center',
                            justifyContent: 'center',
                            gap: 1,
                            bgcolor: 'background.paper',
                            borderTopRightRadius: 12,
                            borderBottomRightRadius: 12,
                            boxShadow: 3,
                            zIndex: 10
                        }}
                    >
                        {alerts}
                    </Box>
                )

            ) : (

                <Container
                    maxWidth={false}
                    sx={{
                        display: 'flex',
                        flexWrap: 'wrap',
                        rowGap: 2,
                        columnGap: 4,
                        justifyContent: 'center'
                    }}
                >
                    {!canTripsOnly && !isOperationalMapMode && alerts}
                </Container>

            )}
            <HourRangeFilter />
        </>
    );

};

export default TopAlerts;